import { JKName } from '../../components/JKName';
import { useGeneralInfo } from '../../hooks';
import { stopPropagation } from 'shared/utils/event';

export function JKNameContainer() {
  const { geo } = useGeneralInfo();

  if (!geo?.jk) {
    return null;
  }

  return <JKName {...geo.jk} onClick={stopPropagation} />;
}
